export function undefinedToNull(o){
    if(o === undefined){
      return null;
    }
    return o;
  }

  export function undefinedToFalse(o){
    if(o === undefined){
      return false;
    }
    return o;
  }

  export enum ProfileTypes {
    Estandar = "estandar",
    Creador = "creador"
}